module.exports = __webpack_public_path__ + "img/stripe-logo-gray.16527cba.svg";